import loading from "@/components/loading.vue";
export default {
    loading
}